// Neu (SPEC 03 §7.1 `*`) — ein Weg, den die Anwendung nicht kennt.
import { useNavigate } from "react-router-dom";
import { Btn, Icon } from "../components/ui";
import { LeerLineatur } from "../components/app/LeerBild";
import { useTitel } from "../hooks/useTitel";
import { TX } from "../lib/texte";

export function NichtGefunden() {
  useTitel("Nicht gefunden");
  const navigate = useNavigate();
  return (
    <section className="card hinweisseite karte-ein" aria-labelledby="nf-titel">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <LeerLineatur />
      </div>
      <h1 id="nf-titel">{TX.fehler.nichtGefunden}</h1>
      <p>Vielleicht ein alter Verweis. Codes und Permalinks (/r/…) führen immer zum richtigen Ort.</p>
      <div className="reihe wrap" style={{ justifyContent: "center", marginTop: 22 }}>
        <Btn type="button" icon="arrow-left" variant="ghost" onClick={() => navigate(-1)}>
          {TX.allgemein.zurueck}
        </Btn>
        <Btn type="button" icon="chart-bar" onClick={() => navigate("/", { replace: true })}>
          {TX.fehler.zurAuswertung}
        </Btn>
      </div>
      <p style={{ marginTop: 18, fontSize: 12 }}>
        <Icon name="info" size={13} /> {TX.anmelden.zugang}
      </p>
    </section>
  );
}

export default NichtGefunden;
